<div class="edit-box-container">
  <p class="edit-box-title">Edit Custom Question</p>
  <textarea #textAreaElement class="input-text-box" [value]="text"></textarea>
  <hr>
  <div class="save-button-container">
    <button id="edit-box-save-button"
            matTooltip="Save"
            (click)="submitTextChange()">
      <img src="assets/icons/save_icon.svg" alt="save icon"/>
    </button>
  </div>
</div>
